<template>
	<div>
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
		<div class="row h-100 d-flex justify-content-center">
			<div class="col-4 pr-0">
				<div class="grayBox mb-2 py-3 px-2">
					<div class="processingBar d-flex align-items-center mb-3">
						<div class="set-size charts-container mr-3">
							<div class="pie-wrapper progress-45 style-2">
								<vue-circle :progress=userCstep * 33 :size="60" :reverse="false" line-cap="round" :fill="fill"
									empty-fill="rgba(0, 0, 0, .1)" :animation-start-value="0.0" :start-angle="135"
									insert-mode="append" :thickness="3" :show-percent="true" ref="completeCircle">
									<!-- <p>Slot!</p> -->
								</vue-circle>
							</div>
						</div>
						<div class="pieText">
							<p> {{ $t('welcm_fewStepAway') }}</p>
							<h3> {{ $t('welcm_activateFxviewAccountNow') }}</h3>
						</div>
					</div>
					<div class="setUpFxaccount">
						<div class="icotitle mb-3" :class="setUpFxaccount ? 'active' : ' '">
							<h3 class="tbIn-mob" @click.prevent="setUpFxaccount = !setUpFxaccount">
								<span class="untitled">
									<img src="../../../../static/fxView/images/steps.svg" alt="">
									{{ $t('welcm_setupFxViewAcc') }}
								</span>
								<span class="clickView">
									<feather type="chevron-down"></feather>
								</span>
							</h3>
						</div>
						<ul class="stepListing">

							<li v-for="(cnt, key) in steps"
								:class="(parseInt(get_user.step) + 1 == key + 1 ? 'active' : '') || (tillCompletedTask(key) ? 'complete' : '')">
								<div class="left" @click.prevent="getBacktoStep(key)">
									<i class="ico">{{ key + 1 }}</i>
									{{ cnt }}
								</div>
								<span class="currentstep">
									<feather type="check"></feather>
								</span>
								<span class="modify" @click.prevent="modifyStep(key)"
									v-if="(tillCompletedTask(key) && parseInt(get_user.profile.ipv_status))"> View</span>
								<span class="modify" @click.prevent="modifyStep(key)"
									v-if="(tillCompletedTask(key) && !(parseInt(get_user.profile.ipv_status)))">
									{{ $t('welcm_modify') }}</span>
							</li>
						</ul>
					</div>
				</div>
				<div class="grayBox py-3 px-2 mb-2 hideForMob">
					<div class="setUpFxaccount  py-0">
						<div class="icotitle">
							<h3>
								<img src="../../../../static/fxView/images/add_funds.svg" alt="">
								{{ $t('welcm_addFund') }}
							</h3>
						</div>
					</div>
				</div>
				<div class="grayBox py-3 px-2 mb-2 hideForMob">
					<div class="setUpFxaccount  py-0">
						<div class="icotitle">
							<h3>
								<img src="../../../../static/fxView/images/start_trading.svg" alt="">
								{{ $t('welcm_startTrading') }}
							</h3>
						</div>
					</div>
				</div>
			</div>
			<div class="col-8">
				<div class="grayBox" v-if="get_user.fresh_user || openDemoAccount">
					<app-register-steps></app-register-steps>
				</div>
				<div v-else>
					<div class="congrtsMessage mb-2 d-flex align-items-center">
						<div class="desc">
							<h2> {{ $t('welcm_welcomeFxView') }}</h2>
							<p class="mb-3"> {{ $t('welcm_welFxviewCon') }}</p>

							<a href="#" class="btn_xs grd_btn" @click.prevent="getBacktoStep(getCurrentSteps())">
								{{ $t('welcm_completeReg') }} </a>
						</div>
						<div class="wlcthumb">
							<img src="../../../../static/fxView/images/platform.svg" alt="" class="platfromThumb">

						</div>
					</div>
					<div class="grayBox p-4">
						<div class="innerTitle pb-3 mb-3 border-bottom">
							<h2> {{ $t('welcm_tryDemoAcc') }}</h2>
						</div>
						<div class="d-flex createDemoBox align-items-center py-3 mb-4">

							<p class="w-75 pr-sm-5 mb-xs-3"> {{ $t('welcm_tryDemoAccCon') }}</p>

							<router-link :to="'/create-demo-account'" class="prism_btn btn_sm darkBG">
								{{ $t('welcm_createDemoAccount') }}</router-link>

						</div>

						<div class="innerTitle pb-3 mb-3 border-bottom">
							<h2> {{ $t('welcm_downloadPlatform') }}</h2>
						</div>

						<div class="downloadPlatform indexplatformdownload d-flex align-items-center ">

							<div class="dpBox d-flex align-items-center">
								<router-link to="/download-platform">
									<div class="ico">
										<img src="../../../../static/fxView/images/platforn-icon-1.svg" alt="">
									</div>
									<div class="desc">
										<h4>{{ $t('welcm_MT4') }}</h4>
										<p>{{ $t('welcm_winIosAndroid') }}</p>
									</div>
								</router-link>
							</div>
							<div class="dpBox d-flex align-items-center">
								<router-link to="/download-platform">
									<div class="ico">
										<img src="../../../../static/fxView/images/platforn-icon-3.svg" alt="">
									</div>
									<div class="desc">
										<h4>{{ $t('welcm_MT5') }}</h4>
										<p>{{ $t('welcm_winIosAndroid') }}</p>
									</div>
								</router-link>
							</div>
							<div class="dpBox d-flex align-items-center">
								<router-link to="/download-platform">
									<div class="ico">
										<img src="../../../../static/fxView/images/platforn-icon-2.svg" alt="">
									</div>
									<div class="desc">
										<h4 v-html="$t('welcm_actTrader')"></h4>
										<p> {{ $t('welcm_winIosAndroid') }}</p>
									</div>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-5 mb-5" v-if="!(get_user.fresh_user || openDemoAccount)">
			<div class="col-12 text-center">
				<h3 class="bold"> {{ $t('welcm_rangeTradTools') }}</h3>
			</div>
		</div>
		<div class="row" v-if="!(get_user.fresh_user || openDemoAccount) && subPlanList.totalRecords > 0">
			<div class="col-4" v-for="list in subPlanList.records" v-if="parseInt(list.id) != 4">
				<div class="glimpseBox mb-3">
					<h4 class="border-bottom pb-3 mb-3"> {{ list.plan_name }}</h4>
					<p class="mb-3" v-if="parseInt(list.id) == 1">{{ $t('welcm_wlcmMsz1') }}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 2">{{ $t('welcm_wlcmMsz2') }}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 3">{{ $t('welcm_wlcmMsz3') }}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 5">{{ $t('welcm_wlcmMsz4') }}</p>
					<p class="mb-3" v-if="parseInt(list.id) == 6">{{ $t('welcm_wlcmMsz5') }} </p>
					<router-link :to="'/auto-chartist'" class="prism_btn btn_sm" title="subscribe" data-placement="top"
						data-toggle="tooltip" v-if="parseInt(list.id) == 1">
						{{ $t('welcm_SeeMore') }}
					</router-link>
					<router-link :to="'/signal-centre'" class="prism_btn btn_sm" title="subscribe" data-placement="top"
						data-toggle="tooltip" v-if="parseInt(list.id) == 2">
						{{ $t('welcm_SeeMore') }}
					</router-link>
					<router-link :to="'/trade-news'" class="prism_btn btn_sm" title="subscribe" data-placement="top"
						data-toggle="tooltip" v-if="parseInt(list.id) == 3">
						{{ $t('welcm_SeeMore') }}
					</router-link>
					<router-link :to="'/economic-calendar'" class="prism_btn btn_sm" title="subscribe" data-placement="top"
						data-toggle="tooltip" v-if="parseInt(list.id) == 5">
						{{ $t('welcm_SeeMore') }}
					</router-link>
					<router-link :to="'/vps-list'" class="prism_btn btn_sm" title="subscribe" data-placement="top"
						data-toggle="tooltip" v-if="parseInt(list.id) == 6">
						{{ $t('welcm_SeeMore') }}
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {
	RUN_USER_LOGIN, RUN_USER_SIGNUP, RUN_VERIFY_LEAD_OTP, RUN_USER_LOGOUT, SET_TOGGLE_LOADER, SET_INFO, SET_STATE, SET_STATE_PERSIST_LOCAL,
	RUN_SAVE_USER_NAME, RUN_REGISTER_STEP1, RUN_REGISTER_STEP2, RUN_REGISTER_STEP3, RUN_REGISTER_STEP4, RUN_REGISTER_STEP5, RUN_SKIP_DOCUMENT_UPLOAD, GET_TOKEN,
	RUN_GET_QUESTION_ANSWER, RUN_STATE_LOAD, RUN_USER_FORGOT_PASSWORD, RUN_GET_USER_IP, RUN_GENERATE_2FA_QRCODE, RUN_VERIFY_2FA_QRCODE, RUN_FINANCIAL_DETAILS
} from '@/types'
import appregistersteps from '../registerSteps/register_steps'
import { fxViewMixins } from '@/plugins/fxView'
import VueCircle from 'vue2-circle-progress'
export default {
	name: 'Dashboard',
	mixins: [fxViewMixins],
	data() {
		return {
			demo: 0,
			live: 1,
			openDemoAccount: 0,
			setUpFxaccount: false,
			pageLoader: false,
			response_msg: '',
			msg_type: '',
			userStep: 0,
			fill: { color: "#25c16f" },
			steps: ['Personal Information', 'Declaration', 'Upload Personal Documents']
		}
	},
	components: {
		appRegisterSteps: appregistersteps,
		VueCircle
	},
	methods: {
		modifyStep(backto) {
			let currentStep = this.get_user.step
			if ('tempStep' in this.get_user && currentStep < this.get_user.tempStep) {
				currentStep = this.get_user.tempStep
			}
			this.get_user.tempStep = currentStep
			this.get_user.step = backto
			let user_json = this.get_user
			this.$store.commit(SET_STATE, user_json)
		},
		getBacktoStep(backto) {
			let currentStep = this.get_user.step
			if ('tempStep' in this.get_user && currentStep < this.get_user.tempStep) {
				currentStep = this.get_user.tempStep
			}
			if (currentStep >= backto) {
				this.get_user.tempStep = currentStep
				this.get_user.step = backto
				this.get_user.fresh_user = 1
				let user_json = this.get_user
				this.$store.commit(SET_STATE, user_json)
			}
			localStorage.setItem("demo_live", 1)
		},
		getCurrentSteps() {
			let currentStep = this.get_user.step
			if ('tempStep' in this.get_user && currentStep < this.get_user.tempStep) {
				currentStep = this.get_user.tempStep
			}
			this.userStep = currentStep
			return currentStep
		},
		tillCompletedTask(key) {
			let userActualStep = 0
			const userInfo = this.get_user
			if ("tempStep" in userInfo) {
				if (userInfo['tempStep'] < userInfo.step) {
					userActualStep = userInfo.step
				} else {
					userActualStep = userInfo['tempStep']
				}
			} else {
				userActualStep = userInfo.step
			}
			if (key < parseInt(userActualStep)) {
				return true
			} else {
				return false
			}
		}
	},
	computed: {
		userCstep: function () {
			let currentStep = this.get_user.step
			if ('tempStep' in this.get_user && currentStep < this.get_user.tempStep) {
				currentStep = this.get_user.tempStep
			}
			this.userStep = currentStep
			if (this.$refs.completeCircle) {
				this.$refs.completeCircle.updateProgress(this.userStep * 33);
			}
			return this.get_user.step
		},
	},
	created() {
		this._runGetSubPlanList({ 'globalParams': {}, 'localParams': { 'parameter': this } })
	}

}
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/welcome.vue